// extracted by mini-css-extract-plugin
export var modal = "_vt-0";
export var table = "_vt-1";